import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row list-unstyled mt-3 mx-auto p-inline-start-0"
}
const _hoisted_2 = { class: "d-flex row reservation-overview no-underline" }
const _hoisted_3 = { class: "col-12 col-md-3 p-2 px-4 bg-darker bg-hover-dark font-weight-bold d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "col-12 col-md-9 d-flex align-items-center" }
const _hoisted_6 = { class: "saal-desc p-2" }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { class: "ml-auto" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "row mt-3" }
const _hoisted_12 = { class: "col-12 col-md-4 offset-md-4" }
const _hoisted_13 = { class: "col-12 d-flex justify-content-end mt-3 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_link_arrow = _resolveComponent("link-arrow")!
  const _component_link_default = _resolveComponent("link-default")!
  const _component_button_panic = _resolveComponent("button-panic")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_link_faq = _resolveComponent("link-faq")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.yourReservations.title')), 1),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        (_ctx.tickets.length === 0)
          ? (_openBlock(), _createBlock(_component_error_message, {
              key: 0,
              class: "my-3",
              i18nMessage: "views.yourReservations.noReservations"
            }))
          : _createCommentVNode("", true),
        (_ctx.tickets.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "col-12 mb-2"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_ctx.formatDay(ticket)), 1),
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_ctx.formatTimeOnly(ticket)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h2", _hoisted_7, _toDisplayString(ticket.roomName), 1),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(ticket.roomDescription), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_button_delete, {
                          i18nMessage: "common.ticketCancel",
                          onClicked: ($event: any) => (_ctx.cancelTicket(ticket)),
                          iconOnly: true,
                          class: "btn-outline-icon-only btn-outline-icon-text-black"
                        }, null, 8, ["onClicked"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.hasRemainingTime())
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.$tc('views.yourReservations.infoText', _ctx.remainingMinutes())), 1))
          : _createCommentVNode("", true),
        (_ctx.tickets.length < _ctx.maxReservations)
          ? (_openBlock(), _createBlock(_component_link_arrow, {
              key: 3,
              i18nMessage: "common.addMoreReservations",
              to: "/"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_ctx.tickets.length > 0)
              ? (_openBlock(), _createBlock(_component_link_default, {
                  key: 0,
                  to: "/your-personal-data",
                  i18nMessage: "views.yourReservations.proceedToYourData",
                  class: "btn btn-outline-brand1 w-100 link-to-outline-btn"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_button_panic, { class: "btn-to-danger-link d-flex justify-content-end pr-3 mt-5" })
      ]),
      _: 1
    }, 8, ["state"]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_link_faq)
    ])
  ]))
}